import IconButton from "../../../../../../packages/design-system/src/IconButton/index.tsx";
import CloseIcon from "../../../../../../packages/design-system/src/Icons/CloseIcon";
import * as React from 'react';
export default {
  IconButton,
  CloseIcon,
  React
};